import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Autocomplete, TextField } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const SearchableAutoComplete = ({ field, formik }) => {
  const isError = formik.touched[field.name] && Boolean(formik.errors[field.name]);

  // Reset Formik field values when empty
  useEffect(() => {
    if (!formik.values[field.name]) {
      formik.setFieldValue(field.name, ""); // Reset main field
      formik.setFieldValue(field.otherField, ""); // Reset other field if applicable
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik?.values[field?.name]]);

  const fieldValue = formik.values[field.name];
  const otherFieldValue = formik.values[field.otherField];
  let selectedValue = null;
  if (fieldValue) {
    if (fieldValue === field.othersValue && otherFieldValue) {
      selectedValue = { name: otherFieldValue, value: field.othersValue };
    } else {
      selectedValue = (field.options || []).find((opt) => opt.value === fieldValue) || null;
    }
  }

  let arrowColor = "#4F5E71";
  if (field.isDisableField) {
    arrowColor = "#b1bac9";
  } else if (isError) {
    arrowColor = "red";
  }

  return (
    <Autocomplete
      disabled={field?.isDisableField}
      freeSolo
      disableClearable
      options={field.options || []}
      getOptionLabel={(option) => option?.name || ""}
      value={selectedValue}
      onChange={(event, newValue) => {
        if (newValue && typeof newValue !== "string") {
          formik.setFieldValue(field.name, newValue.value);
          formik.setFieldValue(field.otherField, "");
        } else {
          formik.setFieldValue(field.name, field.othersValue);
          formik.setFieldValue(field.otherField, newValue || "");
        }
      }}
      onInputChange={(event, newInputValue) => {
        if (!newInputValue) {
          formik.setFieldValue(field.name, ""); // ✅ Clears field when input is empty
          formik.setFieldValue(field.otherField, "");
        } else if (event?.type === "change") {
          formik.setFieldValue(field.name, field.othersValue);
          formik.setFieldValue(field.otherField, newInputValue);
        }

      }}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{
            "& .MuiOutlinedInput-root": {
              height: "46px",
              padding: "10px 14px 10px 0px",
              borderRadius: "8px",
              boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
              fontSize: "14px",
              fontWeight: "400",
              backgroundColor: formik.values[field.name] === field.othersValue ? "#f9fafb" : "inherit",
              cursor: field?.isDisableField || field?.readonly ? "not-allowed" : "pointer",
              "&.Mui-disabled": {
                backgroundColor: "#F9FAFB",
                cursor: "not-allowed",
              },
            },
            "& .MuiInputBase-input": {
              height: "100%",
              fontSize: "14px",
              textTransform: "initial",
              marginLeft: "5px",
              cursor: field?.isDisableField || field?.readonly ? "not-allowed" : "text",
            },
            "& .MuiInputBase-input::placeholder": {
              fontSize: "14px",
              color: "#605E71",
              opacity: 1,
            },
          }}
          placeholder={field.placeholder}
          required={false} // ✅ Prevents native tooltip validation
          error={isError} // ✅ Shows error only if touched
          helperText={isError ? formik.errors[field.name] : ""}
          InputProps={{
            ...params.InputProps,
            type: "search",
            readOnly: field.readonly,
            endAdornment: params.inputProps.value ? null : (
              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  display: "flex",
                  alignItems: "center",
                  pointerEvents: "none",
                  cursor: field?.isDisableField || field?.readonly ? "not-allowed" : "pointer",
                }}
              >
                <KeyboardArrowDownIcon style={{
                  width: "20px",
                  height: "20px",
                  color: arrowColor
                }} />
              </span >
            ),
          }}
        />
      )}
    />
  );
};



SearchableAutoComplete.propTypes = {
  field: PropTypes.any,
  formik: PropTypes.object,
};

export default SearchableAutoComplete;
